import { useQuery } from '@tanstack/react-query';
import planService, { Plan } from '@/services/plan.service';

const PUBLIC_PLANS_STALE_TIME_MS = 5 * 60 * 1000;

/**
 * Planos públicos ativos, direto de `/public/plans` (dados reais do banco,
 * ordenados por preço). Fonte única para telas de bloqueio/upgrade — nunca
 * usar nomes de planos fixos no código.
 */
export function usePublicPlans() {
  return useQuery<Plan[]>({
    queryKey: ['public-plans'],
    queryFn: () => planService.listPublicPlans(),
    staleTime: PUBLIC_PLANS_STALE_TIME_MS,
  });
}

/** Nomes reais dos planos públicos ativos. */
export function usePublicPlanNames(): string[] {
  const { data: plans } = usePublicPlans();
  return (plans ?? []).map((plan) => plan.name);
}

/**
 * Nomes reais dos planos públicos ativos que incluem a funcionalidade
 * (por slug). Vazio enquanto carrega ou quando nenhum plano a inclui —
 * nesse caso a UI deve omitir a linha, nunca inventar um nome.
 */
export function usePlanNamesWithFeature(featureSlug: string | null): string[] {
  const { data: plans } = usePublicPlans();
  if (!featureSlug || !plans) return [];
  return plans
    .filter((plan) =>
      (plan.plan_features ?? []).some(
        (feature) => feature.slug === featureSlug && feature.is_enabled
      )
    )
    .map((plan) => plan.name);
}
